<template>
  <MobileMenu v-if="showSiteChrome && isMobile" />
  <PCMenu v-else-if="showSiteChrome" />
  <router-view />
  <MobileFooter v-if="showSiteChrome && isMobile && showFooter" />
  <PCFooter v-if="showSiteChrome && !isMobile" />
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount, watch } from 'vue';
import { useRoute } from 'vue-router';
import MobileMenu from './components/MobileMenu.vue';
import PCMenu from './components/PCMenu.vue';
import MobileFooter from './components/MobileFooter.vue';
import PCFooter from './components/PCFooter.vue';

const isMobile = ref(false);
const showFooter = ref(true);
const route = useRoute();
const showSiteChrome = computed(() => route.name !== 'invoice');

const checkDevice = () => {
  isMobile.value = window.innerWidth < 900;
};

watch(() => route.name, (newRouteName) => {
  showFooter.value = (
    newRouteName !== 'menus' 
    && newRouteName !== 'today' 
    && newRouteName !== 'lookup' 
    && newRouteName !== 'lookupparts' 
    && newRouteName !== 'mailbox'
    && newRouteName !== 'sendmail'
    && newRouteName !== 'maildetail'
    && newRouteName !== 'workdetail'

    && newRouteName !== 'dispatchmenus-mobile'
    && newRouteName !== 'adminmenus-mobile'

    && newRouteName !== 'dispatcher-mobile'
    && newRouteName !== 'technician-mobile'
    && newRouteName !== 'goods-mobile'

    && newRouteName !== 'dashboard-mobile'

    && newRouteName !== 'menus-mobile' 
    && newRouteName !== 'today-mobile' 
    && newRouteName !== 'lookup-mobile' 
    && newRouteName !== 'lookupparts-mobile' 
    && newRouteName !== 'mailbox-mobile'
    && newRouteName !== 'sendmail-mobile'
    && newRouteName !== 'maildetail-mobile'
    && newRouteName !== 'workdetail-mobile'

    && newRouteName !== 'order-mobile'
    && newRouteName !== 'contractor-mobile'
    && newRouteName !== 'contractordetail-mobile'
    && newRouteName !== 'contractor-workorder-search-mobile'
    && newRouteName !== 'techsupport-mobile'
  );
});

onMounted(() => {
  checkDevice();
  window.addEventListener('resize', checkDevice);
  showFooter.value = route.name !== 'menus';
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkDevice);
});
</script>